// app/routes/news/$newsSlug.jsx;
import Header from '../components/header'
import Footer from '../components/footer'
import { useLoaderData, Link, useNavigate, useLocation } from '@remix-run/react'
import SharePopover from '../components/sharePopover'
import { json } from '@remix-run/node'
import { limitWords, extractFirstImage, decodeHTMLEntities } from '../utils/functions'

export const loader = async ({ params }) => {
  const response = await fetch(`${process.env.WORDPRESS_BACKEND}/posts?slug=${params.newsSlug}&_embed=1`)
  if (!response.ok) {
    throw new Response('Not Found', { status: 404 })
  }
  const post = await response.json()
  if (post.length === 0) {
    throw new Response('Not Found', { status: 404 })
  }

  // Fetch author data using the author ID
  const authorResponse = await fetch(`${process.env.WORDPRESS_BACKEND}/users/${post[0].author}`)
  const author = await authorResponse.json()

  return json({ post: post[0], author, baseUrl: process.env.BASE_URL })
}

export const meta = ({ data }) => {
  const post = data?.post
  return [
    { title: decodeHTMLEntities(post.title.rendered) },
    {
      name: 'description',
      content:
        'There is immense talent within refugee populations. We are a non-profit talent sourcing partner helping employers source and relocate talent from within refugee populations.',
    },
    {
      property: 'og:title',
      content: decodeHTMLEntities(post.title.rendered),
    },
    {
      property: 'og:description',
      content: decodeHTMLEntities(limitWords(post.excerpt.rendered.replace(/<[^>]*>/g, ''), 30)),
    },
    {
      property: 'og:image',
      content: extractFirstImage(post.content.rendered, post),
    },
    {
      property: 'og:url',
      content: 'https://www.talentlift.ca/' + post.slug,
    },
  ]
}

export default function NewsSlug() {
  const { post, author, baseUrl } = useLoaderData()
  const navigate = useNavigate()
  const location = useLocation()
  const from = location.state?.from || '/news'

  const getFullUrl = (path) => {
    return `${baseUrl}/${path}`
  }

  const handleBackClick = () => {
    navigate(from)
  }

  if (!post) return <p>Loading...</p>

  const postDate = new Date(post.date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })

  return (
    <>
      <Header
        title="WHAT'S NEW AT TALENTLIFT"
        subtitle=""
        backgroundimage="/images/news/news_background.png"
        ishomepage={false}
      />
      <main>
        <section className="tl-container">
          <div className="max-w-prose mx-auto">
            <div className="mb-8">
              <h1 className="text-4xl font-bold mb-2">{decodeHTMLEntities(post.title.rendered)}</h1>
              <p className="text-gray-500">
                Posted on {postDate} by{' '}
                <Link className="text-pointed" to={`/news/?a=${encodeURIComponent(author.slug)}`} reloadDocument>
                  {author.name}
                </Link>
              </p>
              <div className="flex items-center mt-4">
                <SharePopover url={getFullUrl(post.slug)} />
              </div>
            </div>
            <div className="mb-16">
              <div
                className="prose text-body"
                dangerouslySetInnerHTML={{
                  __html: post.content.rendered,
                }}
              />
            </div>
            <hr className="mb-8" />
            <button
              className="text-grey60 py-4 px-8 border-2 border-grey5 rounded-full text-btn-line hover:bg-grey70 hover:text-white transition duration-300"
              onClick={handleBackClick}
            >
              BACK
            </button>
          </div>
        </section>
      </main>
      <Footer />
    </>
  )
}
